import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, Button, TextInput } from "hesus-ui-kit";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { priceTypes } from "@utils/constants";
import {
  HeaderWrapper,
  Title,
  FormBody,
  FlexRow,
  OptionsWrapper,
  SectionContent,
  GridRow,
  ValidationMessage,
  ButtonWrapper,
  CenterContent,
  ValidationMessageSpan,
} from "./QuoteView.styled";
import { RequiredMessage } from "@utils/extra-style";

const ValidateServicePopUp = (props) => {
  const {
    t,
    onCancelPopUp,
    hesusService,
    combination,
    sellingPriceItem,
    isValidate,
    setQuoteData,
    quoteId,
    itemId,
    setIsRefeshSiteData,
  } = props;

  const [marginError, setMarginError] = useState("");
  const [marginRate, setMarginRate] = useState("");
  const [aveargePrice, setAveargePrice] = useState(0);

  const getPriceType = () => {
    if (combination) {
      if (
        hesusService.needProduct &&
        (!hesusService.needTransport || hesusService.needTransport === 0)
      )
        return 4;
      if (
        hesusService.needTransport &&
        (!hesusService.needProduct || hesusService.needProduct === 0)
      )
        return 3;
    }
    if (
      hesusService.needTransport === true &&
      hesusService.needProduct === true
    )
      return 2;
    if (
      hesusService.needTransport === true &&
      hesusService.needProduct === false
    )
      return 3;
    if (
      hesusService.needTransport === false &&
      hesusService.needProduct === true
    )
      return 4;
  };

  const calculateMargin = (purchasePrice, priceType) => {
    const data = { purchasePrice: {}, sellingPrice: {} };

    let priceTypeText = "";
    if (
      priceType === priceTypes.TransportTreatmentSeparated ||
      priceType === priceTypes.TransportOnly
    ) {
      data.purchasePrice.transport = purchasePrice;
      data.sellingPrice.transport = {
        price: sellingPriceItem?.unitPrice,
        quantity: sellingPriceItem?.quantity,
      };
      priceTypeText = "transport";
    }
    if (
      priceType === priceTypes.TransportTreatmentSeparated ||
      priceType === priceTypes.TreatmentOnly
    ) {
      data.purchasePrice.treatment = purchasePrice;
      data.sellingPrice.treatment = {
        price: sellingPriceItem?.unitPrice,
        quantity: sellingPriceItem?.quantity,
      };
      priceTypeText = "treatment";
    }
    if (priceType === priceTypes.TransportTreatment) {
      data.purchasePrice.transportTreatment = purchasePrice;
      data.sellingPrice.transportTreatment = {
        price: sellingPriceItem?.unitPrice,
        quantity: sellingPriceItem?.quantity,
      };
      priceTypeText = "transportTreatment";
    }

    axios
      .post("/general/v2/calculateMargin", data)
      .then((response) => {
        setMarginRate(response.data[priceTypeText].rate);
        setMarginError("");
      })
      .catch((error) => handleApiError(error));
  };

  const calculateApp = () => {
    const priceType = getPriceType();
    const itemUnit = sellingPriceItem.unit;
    let uppNull = 0;
    let modifiedSolutions = sellingPriceItem?.solutions.map((solutionItem) => {
      if (
        parseInt(solutionItem?.solution.solutionStatus.id, 10) === 7 &&
        parseInt(solutionItem.koStatus, 10) === 1
      ) {
        const upp =
          solutionItem.unitPurchasePrice ??
          solutionItem?.solution?.unitPurchasePrice;
        if (upp?.transport?.price === null) {
          uppNull = 1;
        }
        if (upp?.treatment?.price === null) {
          uppNull = 1;
        }
        if (upp?.transportTreatment?.price === null) {
          uppNull = 1;
        }
        const tempSolution = { ...upp };
        tempSolution.sollutionId = solutionItem.solution.id;
        tempSolution.allocation = solutionItem.koAllocation
          ? solutionItem.koAllocation
          : solutionItem.allocation;
        return tempSolution;
      }
    });
    if (uppNull === 1) {
      setMarginError(
        "KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_ALERT_MARGIN_NOT_CALCULATED"
      );
    }
    if (uppNull !== 1) {
      if (modifiedSolutions?.length > 0) {
        modifiedSolutions = modifiedSolutions.filter(
          (solution) => solution !== undefined
        );
      }
      let priceTypeText = "";
      const requestData = {
        sellingPrice: {
          priceType,
          transportTypeId: sellingPriceItem?.transportType?.id,
        },
        solutions: modifiedSolutions,
      };

      if (
        priceTypes === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TreatmentOnly
      ) {
        requestData.sellingPrice.treatmentUnit = itemUnit;
        priceTypeText = "treatment";
      }
      if (
        priceType === priceTypes.TransportTreatmentSeparated ||
        priceType === priceTypes.TransportOnly
      ) {
        requestData.sellingPrice.transportUnit = itemUnit;
        priceTypeText = "transport";
      }
      if (priceType === priceTypes.TransportTreatment) {
        requestData.sellingPrice.transportTreatmentUnit = itemUnit;
        priceTypeText = "transportTreatment";
      }

      axios
        .post("/sellingPrices/calculateAveragePurchasePrice", requestData)
        .then((response) => {
          setAveargePrice(response.data[priceTypeText].price);
          calculateMargin(response.data[priceTypeText].price, priceType);
          setMarginError("");
        })
        .catch((error) => handleApiError(error));
    }
  };

  useEffect(() => {
    if (isValidate) {
      if (hesusService.needSolution) {
        calculateApp();
      }
      if (!hesusService.needSolution) {
        setMarginRate(100);
        setAveargePrice(0);
      }
    }
  }, [isValidate]);

  const onMarginChange = (e) => {
    setMarginRate(e.target.value);
    setMarginError("");
  };

  const validateForm = () => {
    let isFormValid = true;
    if (!marginRate && marginRate !== 0) {
      isFormValid = false;
      setMarginError("GENERAL_MANDATORY_ERROR");
    }
    if (marginRate && !/^-?\d*[.,]?\d{0,2}$/.test(marginRate)) {
      isFormValid = false;
      setMarginError("GENERAL_FORMAT_ERROR");
    }
    return isFormValid;
  };

  const onSubmit = () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      const data = {
        margin: marginRate,
        koAveragePurchasePrice: aveargePrice,
        koStatus: 1,
      };
      axios
        .put(`/quotes/${quoteId}/item/${itemId}`, data)
        .then((response) => {
          setQuoteData(response.data[0]);
          setMarginError("");
          setIsRefeshSiteData(true);
        })
        .catch((error) => {
          if (window.debugMode) {
            console.error(
              "Error: an error occurred while updating dates",
              error
            );
          }
          // setEditDate(!editDate);
          // setEditDateId("");
        });
    }
  };

  return (
    <Dialog width="33rem">
      <div>
        <HeaderWrapper>
          <Title>
            {t("KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_TITLE")}
          </Title>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContent>
                <div>
                  <GridRow column="1fr">
                    <ValidationMessage>
                      {t(
                        "KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_ALERT_MESSAGE"
                      )}
                    </ValidationMessage>
                  </GridRow>
                  <GridRow column="1fr">
                    <CenterContent>
                      <ValidationMessageSpan
                        margin="0"
                        lineHeight="20px;"
                        paddingTop="10px"
                      >
                        {t(
                          "KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_FORM_MARGIN"
                        )}
                      </ValidationMessageSpan>
                      {/* <TextInput
                        id="kickoff-validateservice-margin"
                        type="text"
                        inputClass="search-box-default-input"
                        value={marginRate}
                        onChange={onMarginChange}
                        placeholder=""
                        name="kickoff-validateservice-margin"
                        inputStyles={{
                          maxWidth: "3rem",
                          border: "0",
                          borderBottom: "2px solid rgba(74, 144, 226, 1)",
                          marginLeft: "10px",
                        }}
                      /> */}
                      <input
                        type="text"
                        value={marginRate}
                        style={{
                          maxWidth: "3rem",
                          border: "0",
                          borderBottom: "2px solid rgba(74, 144, 226, 1)",
                          marginLeft: "10px",
                        }}
                        onChange={onMarginChange}
                      />
                      %
                    </CenterContent>
                  </GridRow>
                  {marginError !== "" && (
                    <GridRow column="1fr">
                      <CenterContent>
                        <RequiredMessage>{t(marginError)}</RequiredMessage>
                      </CenterContent>
                    </GridRow>
                  )}
                </div>
              </SectionContent>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>
        <ButtonWrapper content="flex-end" padding="1.375rem">
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {t(
                "KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_BUTTON_VALIDATE"
              )}
              {/* {isPaymentTermCreating && <ClipLoader size={15} color="#fff" />} */}
              {/* {!isPaymentTermCreating && t("SUBMIT")} */}
            </>
          </Button>

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onCancelPopUp}
          >
            {t("KICK_OFF_PAGE_QUOTE_SOLUTIONS_VALIDATION_POPUP_BUTTON_CANCEL")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

ValidateServicePopUp.propTypes = {
  onCancelPopUp: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ValidateServicePopUp);
